module.exports = __webpack_public_path__ + "static/media/caretDown.72c03599.svg";